'use strict';

/**
 * @ngdoc overview
 * @name vTvPackageServices
 * @description
 * # Module
 */
angular.module('v-tv-package', ['ngAria', 'angulartics', 'angulartics.google.tagmanager', 'ngSanitize', 'pascalprecht.translate', 'v-tv-package-services', 'v-ui-components', 'ngDialog', 'v-core.config']);